import React, { useState, useEffect } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { ItemsList } from "./utils"
import DesignTokens from "./designTokens"
import { CookiesProvider } from "react-cookie"
import { useCookies } from "react-cookie"

const PrimaryMenu = () => {
  const [showMenu, setShowMenu] = useState(false)
  const [cookies, setCookies] = useCookies(["newsNotification"])

  return (
    <CookiesProvider>
      <ItemsList>
        <Item
          onMouseEnter={() => setShowMenu(!showMenu)}
          onMouseLeave={() => setShowMenu(!showMenu)}
        >
          <a>Soluzioni</a>
          {showMenu && (
            <Dropdown>
              <li>
                <Link to="/impianti-elettrici-mt-mb-e-speciali">
                  Impianti elettrici MT/BT e speciali
                </Link>
              </li>
              <li>
                <Link to="/impianti-tecnologici">Impianti tecnologici</Link>
              </li>
              <li>
                <Link to="/reti-e-trasmissione-dati">
                  Reti e trasmissione dati
                </Link>
              </li>
              <li>
                <Link to="/energie-rinnovabili">Energie rinnovabili</Link>
              </li>
            </Dropdown>
          )}
        </Item>
        <Item>
          <Link to="/settori">Settori</Link>
        </Item>
        <Item>
          <Link to="/referenze">Referenze</Link>
        </Item>
        <Item>
          <Link to="/consulenza-risparmio-energetico">Consulenza</Link>
        </Item>
        <Item>
          <Link to="/certificazioni">Certificazioni</Link>
        </Item>
        <Item>
          <Link to="/azienda">Azienda</Link>
        </Item>
        <Item notification={cookies.newsNotification}>
          <Link to="/news/">
            <span>News</span>
          </Link>
        </Item>
        <Item>
          <Link to="/contatti">Contatti</Link>
        </Item>
      </ItemsList>
    </CookiesProvider>
  )
}

const Item = styled.li`
  a span {
    position: relative;
    &:after {
      content: "";
      width: 10px;
      height: 10px;
      border-radius: 1000px;
      background: ${DesignTokens.colors.secondary[500]};
      position: absolute;
      top: -5px;
      right: -15px;
      display: ${props => (props.notification === "true" ? "none" : "block")};
    }
  }
`

const Dropdown = styled(ItemsList)`
  margin-top: 1rem;
  & > li {
    display: flex;
    a {
      text-align: center;
      width: 100%;
      color: ${DesignTokens.colors.white};
      font-size: ${DesignTokens.fontSizes[4]};
      text-decoration: none;
    }
  }
  @media screen and (min-width: 769px) {
    margin-top: 0;
    text-align: left;
    background: ${DesignTokens.colors.white};
    position: absolute;
    display: flex;
    flex-direction: column;
    & > li {
      display: inline-flex;
      margin: 0;
      a {
        text-align: left;
        width: 100%;
        padding: ${DesignTokens.spacing[2]} ${DesignTokens.spacing[4]};
        color: ${DesignTokens.colors.primary[500]};
        text-decoration: none;
        &:hover {
          color: ${DesignTokens.colors.secondary[500]};
          background-color: ${DesignTokens.colors.primary[500]};
        }
      }
    }
  }
`

export default PrimaryMenu
